// extracted by mini-css-extract-plugin
module.exports = {"header":"OeTK","chatTitle":"kayw","title":"dfTS","leftAddon":"c3eK","rightAddon":"ZNmD"};